import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { homeHeroSlides } from '@/mocks/videos';

export default function HeroBanner() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goToSlide = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide(index);
    setTimeout(() => setIsTransitioning(false), 600);
  }, [isTransitioning]);

  useEffect(() => {
    const timer = setInterval(() => {
      goToSlide((currentSlide + 1) % homeHeroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [currentSlide, goToSlide]);

  const slide = homeHeroSlides[currentSlide];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={slide.image}
          alt={slide.title}
          className="w-full h-full object-cover object-top transition-opacity duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-[800px] mx-auto">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-500/20 text-primary-300 text-xs font-medium mb-4 whitespace-nowrap backdrop-blur-sm">
            热播推荐
          </span>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
            {slide.title}
          </h1>
          <p className="text-sm md:text-lg text-background-200 mb-8 max-w-[600px] mx-auto leading-relaxed">
            {slide.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to={`/article/${slide.videoId}`}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-circle-fill text-lg"></i>
              立即观看
            </Link>
            <Link
              to={`/article/${slide.videoId}`}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium text-sm transition-all duration-300 cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              <i className="ri-information-line text-lg"></i>
              了解详情
            </Link>
          </div>
        </div>

        <div className="absolute bottom-8 flex items-center gap-2">
          {homeHeroSlides.map((_, index) => (
            <button
              key={index}
              type="button"
              onClick={() => goToSlide(index)}
              className={`w-8 h-1 rounded-full transition-all duration-300 cursor-pointer ${
                index === currentSlide
                  ? 'bg-primary-500 w-10'
                  : 'bg-background-50/40 hover:bg-background-50/60'
              }`}
              aria-label={`切换到第${index + 1}张幻灯片`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}